import {
  BackButton,
  Box,
  ButtonStyled,
  FileUploaderStyled,
  FormElementWrapper,
  LabelStyled,
  LazyImage,
  SeparatorBorder,
  SpanStyled,
  SubHeadingStyled,
  ThemeLoader,
} from "../../../../../components/styled/Elements";
import { Col, FormGroup, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FormDataContainer, ProfileWrapper } from "./styled";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../../../../components/admin/Breadcrumbs/Breadcrumbs";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { ValidatedInputWrapper } from "../../../../../components/common/inputFields/ValidatedInput";
import TypeSelection from "./TypeSelection";
import { addArchiveRadio } from "../../../../../helpers/dummyConstants";
import { getIsTemporary, hasPlanFeature, reqFormatDate } from "../../../../../utils";
import AccessType from "./AccessType";
import Statuses from "./Statuses";
import DatePickerDefault from "../../../../../components/common/inputFields/DatePicker";
import ArchiveDateField from "./ArchiveDateField";
import { DateIcon } from "../../../../../components/styled/AllImages";
import AccessSettings from "../../components/AccessSettings";
import { useState } from "react";
import CabinetsApi from "../../../../../services/api/cabinetsApi";
import { toast } from "react-toastify";

const AddArchive = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id, fileId } = useParams();

  const isTemporary = getIsTemporary();

  const [userSelections, setUserSelections] = useState({
    branch_ids: [],
    department_ids: [],
    user_ids: [],
  });

  const initialValues = {
    title: "",
    description: "",
    archive_type_id: addArchiveRadio[0]?.id,
    attachment: null,
    access_type: null,
    archive_status_id: null,
    date: null,
    no_of_pages: null,
    number: null,
    from: "",
    to: "",
    finalizedFileUrl: "",
    setting_id: 1,
    my_department_id: null,
    my_dept_ids: [],
    other_department_id: null,
    other_dept_ids: [],
    referrals: [],
    from_branches: [],
    from_departments: [],
  };
  const validationSchema = Yup.object().shape(
    {
      my_department_id: Yup.number()
        .nullable()
        .when(["other_department_id", "setting_id"], {
          is: (otherId, settingId) => !otherId && !settingId,
          then: (schema) => schema.required(t("Pleaseselectone")),
          otherwise: (schema) => schema.notRequired(),
        }),

      other_department_id: Yup.number()
        .nullable()
        .when(["my_department_id", "setting_id"], {
          is: (myId, settingId) => !myId && !settingId,
          then: (schema) => schema.required(t("Pleaseselectone")),
          otherwise: (schema) => schema.notRequired(),
        }),

      setting_id: Yup.number()
        .nullable()
        .when(["my_department_id", "other_department_id"], {
          is: (myId, otherId) => !myId && !otherId,
          then: (schema) => schema.required(t("Pleaseselectone")),
          otherwise: (schema) => schema.notRequired(),
        }),

      my_dept_ids: Yup.array()
        .ensure()
        .when("my_department_id", {
          is: (val) => val === 4 || val === 5,
          then: (schema) =>
            schema
              .min(1, t("Please_select_user"))
              .required(t("Please_select_user")),
          otherwise: (schema) => schema.notRequired(),
        }),

      other_dept_ids: Yup.array()
        .ensure()
        .when("other_department_id", {
          is: (val) => [6, 7, 8, 9].includes(val),
          then: (schema) =>
            schema.min(1, t("Required")).required(t("Required")),
          otherwise: (schema) => schema.notRequired(),
        }),
    },
    [
      // Cyclic dependencies array
      ["my_department_id", "other_department_id"],
      ["my_department_id", "setting_id"],
      ["other_department_id", "setting_id"],
    ],
  );
  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    try {
      console.log("values: ", values);
      const formData = new FormData();

      formData.append("action", "create");
      formData.append("title", values.title);
      formData.append("common_settings_id", Number(values.setting_id));
      formData.append("description", values.description); 
      formData.append("archive_type_id", values.archive_type_id); 
      formData.append("archive_status_id", values.archive_status_id); 
      formData.append("date", reqFormatDate(values.date)); 
      formData.append("number", values.number); 
      formData.append("from", values.from); 
      formData.append("to", values.to); 
      formData.append("file_url", values.finalizedFileUrl); 
      formData.append("multipart_flag", !!values.finalizedFileUrl); 
      formData.append("no_of_pages", values.no_of_pages); 
      formData.append("attachment", values.attachment); 
      formData.append("duration", values.duration); 
      formData.append("other_type", values.other_type); 
      formData.append("is_temporary", isTemporary); 
      formData.append("my_department_id", Number(values.my_department_id));
      formData.append("other_department_id", Number(values.other_department_id));
      appendArray(formData, "from_branches", values.from_branches);
      appendArray(formData, "from_departments", values.from_departments);
      appendArray(formData, "my_dept_ids", values.my_dept_ids);
      appendArray(formData, "other_dept_ids", values.other_dept_ids);
      formData.append("referrals", JSON.stringify(values.referrals));
      formData.append("access_type", values.access_type);

      const { code, message } = await CabinetsApi.createArchive(
        id,
        fileId,
        formData
      );
      if (code === 200) {
        toast.success(t("archive_created"));
        navigate(`/cabinets/${id}/files/${fileId}/archives`);
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setSubmitting(false);
    }
  };

  const appendArray = (formData, key, array) => {
    if (Array.isArray(array)) {
      array.forEach((item) => formData.append(`${key}[]`, item));
    }
  };

  return (
    <ProfileWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("add_archive")}
            onClick={() => navigate(`/cabinets/${id}/files/${fileId}/archives`)}
          />
          <Breadcrumbs />
        </Box>
      </Box>
      <Box className="content-container">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => {
            return (
              <Form encType="multipart/form-data">
                <Row className="mt-3">
                  <Col md={12}>
                    <FormDataContainer className="dataContainer">
                      <ValidatedInputWrapper>
                        <FormGroup className="formEleContainer">
                          <LabelStyled
                            className="border-0"
                            size="15px"
                            color="var(--text)"
                          >
                            {t("title")}
                            <span className="staric">*</span>
                          </LabelStyled>

                          <Box className="w-100">
                            {/* Input Field */}
                            <Field
                              type="text"
                              name="title"
                              className="form-control"
                              placeholder={t("title")}
                            />
                            {/* Error Message */}
                            <ErrorMessage
                              name="title"
                              component="div"
                              className="text-danger text-sm mb-0 mt-1"
                            />
                          </Box>
                        </FormGroup>
                      </ValidatedInputWrapper>

                      <TypeSelection />
              
                      <SeparatorBorder className="mt-2" />

                      {hasPlanFeature(2) && <AccessType />}

                      <Statuses />

                      <FormElementWrapper>
                        <Box className="formEleContainer">
                          <LabelStyled className="labelForm">
                            {t("date")}*
                          </LabelStyled>
                          <ArchiveDateField
                            name="date"
                            placeholder="Select Date"
                            monthDropdown={true}
                            yearDropdown={true}
                            icon={DateIcon}
                          />
                        </Box>
                      </FormElementWrapper>

                      <ValidatedInputWrapper>
                        <FormGroup className="formEleContainer">
                          <LabelStyled
                            className="border-0"
                            size="15px"
                            color="var(--text)"
                          >
                            {t("number")}
                          </LabelStyled>

                          <Box className="w-100">
                            {/* Input Field */}
                            <Field
                              type="text"
                              name="number"
                              className="form-control"
                              placeholder={t("number")}
                            />
                            {/* Error Message */}
                            <ErrorMessage
                              name="number"
                              component="div"
                              className="text-danger text-sm mb-0 mt-1"
                            />
                          </Box>
                        </FormGroup>
                      </ValidatedInputWrapper>

                      <ValidatedInputWrapper>
                        <FormGroup className="formEleContainer">
                          <LabelStyled
                            className="border-0"
                            size="15px"
                            color="var(--text)"
                          >
                            {t("from")}
                          </LabelStyled>

                          <Box className="w-100">
                            {/* Input Field */}
                            <Field
                              type="text"
                              name="from"
                              className="form-control"
                              placeholder={t("from")}
                            />
                            {/* Error Message */}
                            <ErrorMessage
                              name="from"
                              component="div"
                              className="text-danger text-sm mb-0 mt-1"
                            />
                          </Box>
                        </FormGroup>
                      </ValidatedInputWrapper>

                      <ValidatedInputWrapper>
                        <FormGroup className="formEleContainer">
                          <LabelStyled
                            className="border-0"
                            size="15px"
                            color="var(--text)"
                          >
                            {t("to")}
                          </LabelStyled>

                          <Box className="w-100">
                            {/* Input Field */}
                            <Field
                              type="text"
                              name="to"
                              className="form-control"
                              placeholder={t("to")}
                            />
                            {/* Error Message */}
                            <ErrorMessage
                              name="to"
                              component="div"
                              className="text-danger text-sm mb-0 mt-1"
                            />
                          </Box>
                        </FormGroup>
                      </ValidatedInputWrapper>

                      <Box className="w-100">
                        <AccessSettings showBaseCabinetOption={true} />
                        <SeparatorBorder />
                        <Box className="commonBtns w-100">
                          <ButtonStyled
                            bg="var(--bgSecondary)"
                            label={t("Cancel")}
                            color="var(--text2)"
                            type="button"
                            onClick={() =>
                              navigate(
                                `/cabinets/${id}/files/${fileId}/archives`,
                              )
                            }
                          ></ButtonStyled>
                          <ButtonStyled
                            type="submit"
                            label={t("Create")}
                            isLoading={isSubmitting}
                          ></ButtonStyled>
                        </Box>
                      </Box>
                    </FormDataContainer>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </ProfileWrapper>
  );
};

export default AddArchive;
